export const FIELD_STATUS = Object.freeze({
  SUCESSO: 'Sucesso',
  ERRO: 'Erro',
  VAZIO: 'Vazio',
  VARIOS: 'Varios',
});
